var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.7215L18.6667 6.34984V11.8332C18.6667 17.1065 15.19 21.9715 10.5 23.4182C5.81 21.9715 2.33333 17.1065 2.33333 11.8332V6.34984L10.5 2.7215ZM10.5 0.166504L0 4.83317V11.8332C0 18.3082 4.48 24.3632 10.5 25.8332C16.52 24.3632 21 18.3082 21 11.8332V4.83317L10.5 0.166504ZM9.33333 7.1665H11.6667V9.49984H9.33333V7.1665ZM9.33333 11.8332H11.6667V18.8332H9.33333V11.8332Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/Inactive.05b29ef03783d1b99b0ae6593d5152cd.svg";
export { ForwardRef as ReactComponent };